import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import AddCardIcon from '@mui/icons-material/AddCard'
import N from 'utils/navigation'

export const PaymentMethodsCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <AddCardIcon />,
        content: t('SetupWizard.PaymentMethodsSummary'),
        buttonText: t('SetupWizard.PaymentMethodsCTA'),
        actionOnClick: () => {
          N.push('/settings/payment-methods/new')
        }
      }}
    />
  )
}
